import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import dmcService from "./dmcService.js";


export const getDMCs = createAsyncThunk("DMC/get-DMCs", async (thunkAPI) => {
    try {
        return await dmcService.getDMCs();
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});
export const createDMC = createAsyncThunk(
    "DMC/create-DMCs",
    async (AssociationData, thunkAPI) => {
        try {
            return await dmcService.createDMC(AssociationData);
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response.data);
        }
    }
);

export const getDMC = createAsyncThunk(
    "DMC/get-DMC",
    async (id, thunkAPI) => {
        try {
            return await dmcService.getDMC(id);
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);
export const updateDMC = createAsyncThunk(
    "DMC/update-DMC",
    async (id, thunkAPI) => {
        try {
            return await dmcService.updateDMC(id);
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);

export const deleteDMC = createAsyncThunk(
    "DMC/delete-DMC",
    async (id, thunkAPI) => {
        try {
            return await dmcService.deleteDMC(id);
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);
export const updateDMCStatus = createAsyncThunk(
    "DMC/update-DMC-status",
    async (id, thunkAPI) => {
        try {
            return await dmcService.updateDMCStatus(id);
        } catch (error) {
            return thunkAPI.rejectWithValue(error);
        }
    }
);
export const resetState = createAction("Reset_all");

const initialState = {
    DMCs: [],
    isError: false,
    isLoading: false,
    isSuccess: false,
    message: "",
};
export const dmcSlice = createSlice({
    name: "dmc",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getDMCs.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getDMCs.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.isSuccess = true;
                state.DMCs = action.payload.data;
            })
            .addCase(getDMCs.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.isSuccess = false;
                state.message = action.error;
            })
            .addCase(createDMC.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(createDMC.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.isSuccess = true;
                state.createdDMC = action.payload;
            })
            .addCase(createDMC.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.isSuccess = false;
                state.message = action.payload;
            })

            .addCase(getDMC.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getDMC.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.isSuccess = true;
                state.chaptersname = action.payload.data.name;
                state.chapterspost = action.payload.data.post;
                state.chaptersabout = action.payload.data.about;
            })
            .addCase(getDMC.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.isSuccess = false;
                state.message = action.error;
            })
            .addCase(updateDMC.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateDMC.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.isSuccess = true;
                state.updatedDMC = action.payload;
            })
            .addCase(updateDMC.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.isSuccess = false;
                state.message = action.error;
            })
            .addCase(deleteDMC.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deleteDMC.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.isSuccess = true;
                state.deletedDMC = action.payload;
            })
            .addCase(deleteDMC.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.isSuccess = false;
                state.message = action.error;
            })
            .addCase(updateDMCStatus.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateDMCStatus.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.isSuccess = true;
                state.updatedDMCStatus = action.payload;
            })
            .addCase(updateDMCStatus.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.isSuccess = false;
                state.message = action.error;
            })
            .addCase(resetState, () => initialState);
    },
});
export default dmcSlice.reducer;
